import { validatePhoneNumber } from '@/lib/validation/phoneValidation';
import z from 'zod';
import { addressSchema } from './addressValidator';

export const forgotPasswordSchema = z.object({
  email: z.string().email('Invalid email address'),
});

export const loginSchema = z.object({
  email: z.string().email('Invalid email address'),
  password: z.string().min(1, 'Password is required'),
});

export const registerSchema = z
  .object({
    name: z.string().min(1, 'First name is required'),
    surname: z.string().min(1, 'Last name is required'),
    email: z.string().email('Invalid email address'),
    password: z
      .string()
      .min(8, 'Password incorrect')
      .regex(/[a-z]/, 'Password incorrect')
      .regex(/[A-Z]/, 'Password incorrect')
      .regex(/[0-9]/, 'Password incorrect'),
    phone: z
      .string()
      .min(1, 'Phone number is required')
      .refine((val) => validatePhoneNumber(val), {
        message: 'Invalid phone number format',
      }),
    phoneCountry: z.string().optional(),
    phoneCode: z.string().optional(),
    ...addressSchema.shape,
  })

  .refine((data) => validatePhoneNumber(data.phone, data.phoneCountry), {
    message: 'Phone number does not match the selected country',
    path: ['phone'],
  });

export const resetPasswordSchema = z.object({
  password: z
    .string()
    .min(8, 'Password incorrect')
    .regex(/[a-z]/, 'Password incorrect')
    .regex(/[A-Z]/, 'Password incorrect')
    .regex(/[0-9]/, 'Password incorrect'),
});

export const acceptInvitationSchema = z.object({
  password: z
    .string()
    .min(8, 'Password incorrect')
    .regex(/[a-z]/, 'Password incorrect')
    .regex(/[A-Z]/, 'Password incorrect')
    .regex(/[0-9]/, 'Password incorrect'),
  phone: z
    .string()
    .min(1, 'Phone number is required')
    .refine((val) => validatePhoneNumber(val), {
      message: 'Invalid phone number format',
    }),
});

export const loginSearchSchema = z.object({
  type: z.string().optional(),
  registered: z.string().optional(),
  registration_id: z.string().optional(),
  reset_id: z.string().optional(),
});
export const registerSearchSchema = z.object({
  name: z.string().optional(),
  surname: z.string().optional(),
  invitation: z.string().optional(),
  email: z.string().optional(),
});
export const resetPasswordSearchSchema = z.object({
  token: z.string().optional(),
  email: z.string().optional(),
  invitation: z.string().optional(),
});
